// extracted by mini-css-extract-plugin
export default {"formSection":"Masks_formSection__RGGTW","footer":"Masks_footer__R7Mpv"};